﻿import { ApiCaller } from 'apis/ApiCaller';

export interface UserFilter{
	Id: number;
	Json?: string;
  Name: string;
}

export class UserFilterApi {

    private static apiCaller = new ApiCaller('UserFilter');

    public static Create(locationId: number, filterName: string, filterJson: string){

		    return this.apiCaller.POST<number>('Create', { filterJson, filterName, locationId });

    }

    public static Update(filterId: number, locationId: number, filterName: string, filterJson: string){

		    return this.apiCaller.PUT<void>('Update', { filterId, filterJson, filterName, locationId });

    }

    public static Delete(filterId: number){

		    return this.apiCaller.DELETE<void>('Delete', { filterId });

    }

    public static GetAll(locationId: number){

		    return this.apiCaller.GET<UserFilter[]>('GetAll', { locationId });

    }

}